import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import DataGridComponent from "@molecules/data-grid/data-grid.component";
import FeatherIcon from "feather-icons-react";
import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";

function ManufacturerListTemplateComponent({
  templateModal: {
    tableTitle,
    keyColumn,
    breadCrumbs,
    tableColumn,
    tableData,
    totalCount,
    filters,
    tableParams,
    tableActions,
  },
  templateEvents: {
    getManufacturerData,
    handleCreateClick,
    deleteRecords,
    submitFilter,
    // handleDownload,
  },
}) {
  const settingFormEdit = `${breadCrumbs[0].menu_url}/edit`;

  const ActionContent = ({ handleCreateClick }) => {
    return (
      <button
        type="button"
        className="btn btn-outline-primary btn-sm"
        onClick={handleCreateClick}
        style={{ marginRight: 10 }}
      >
        <FeatherIcon icon="plus" size={17} />
        &nbsp;
      </button>
    );
  };

  return (
    <PageWrapperComponent>
      <PageHeadComponent
        title={"Manufacturers"}
        breadCrumbs={breadCrumbs}
        actionContent={<ActionContent handleCreateClick={handleCreateClick} />}
      />
      <DataGridComponent
        title={tableTitle}
        keyColumn={keyColumn}
        tableData={tableData}
        tableColumn={tableColumn}
        totalCount={totalCount}
        dataRefresh={getManufacturerData}
        editLink={settingFormEdit}
        deleteRecords={deleteRecords}
        breadCrumbs={breadCrumbs}
        filters={filters}
        submitFilter={submitFilter}
        // handleDownload={handleDownload}
        tableParams={tableParams}
        tableActions={tableActions}
        disableDelete
      />
    </PageWrapperComponent>
  );
}

export default ManufacturerListTemplateComponent;
